module.exports = __webpack_public_path__ + "img/30292-1-134.prt.cfec7b3a.jpg";